import { forwardRef, ReactElement, useCallback, useMemo } from 'react'
import { DateCarouselProps } from './props'
import { Carousel } from '../..'
import Mapper from './mapper'
import Slider from 'react-slick'

const DateCarousel = forwardRef<Slider, DateCarouselProps>(
    (
        {
            dates,
            datesToShow = 14,
            onClickDate: onDateClick = () => undefined,
            onScrollEvent,
            showCloseIcon,
        },
        ref
    ): ReactElement => {
        const shouldShowCloseIcon =
            showCloseIcon === undefined ? true : showCloseIcon
        const dateComponents = useMemo(
            () =>
                dates.map((date) =>
                    Mapper.CarouselItem(date, onDateClick, shouldShowCloseIcon)
                ),
            [dates, onDateClick, shouldShowCloseIcon]
        )

        const beforeChange = useCallback(
            (_previousIndex: number, newIndex: number) => {
                const firstDate = dates[newIndex].date
                const lastDate = dates[newIndex + datesToShow - 1].date
                if (onScrollEvent) onScrollEvent(firstDate, lastDate)
            },
            [dates, datesToShow, onScrollEvent]
        )

        return (
            <Carousel
                beforeChange={beforeChange}
                css={{
                    '.slick-arrow': {
                        '@mobile': {
                            h: '70px',
                            w: '32px',
                        },

                        '@desktop': {
                            h: '80px',
                            w: '40px',
                        },
                    },
                }}
                ref={ref}
                slidesToScroll={datesToShow}
                slidesToShow={datesToShow}
            >
                {dateComponents}
            </Carousel>
        )
    }
)

DateCarousel.displayName = 'Carousel'

export default DateCarousel
